import styled from 'styled-components';

export const Info = styled.div`
  color: ${p => p.theme.colors.text.secondary};
  margin-left: 40px;
`;
